var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 395,
    viewBox: "0 0 409 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1953_40758)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.305 81.1487H178.94C176.755 81.1487 175.17 79.0871 175.721 76.9771L195.081 2.49718C195.468 1.02597 196.792 0 198.3 0H405.666C407.85 0 409.435 2.06163 408.884 4.17165L389.524 78.6516C389.137 80.1228 387.813 81.1487 386.305 81.1487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.385 15.9316H279.539",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.828 49.2852H273.991",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.178 36.6836H304.331",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.53 27.0527H227.181",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.572 36.6836H224.223",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.012 15.9316H316.723",
    stroke: "#A9C2FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.616 64.9268H265.215C265.022 64.9268 264.877 64.7429 264.925 64.559L266.645 57.9482C266.684 57.8224 266.8 57.7256 266.935 57.7256H305.337C305.53 57.7256 305.675 57.9095 305.627 58.0934L303.906 64.7041C303.868 64.83 303.752 64.9268 303.616 64.9268V64.9268Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.878 64.9268H217.476C217.283 64.9268 217.138 64.7429 217.186 64.559L218.907 57.9482C218.945 57.8224 219.061 57.7256 219.197 57.7256H257.598C257.791 57.7256 257.936 57.9095 257.888 58.0934L256.168 64.7041C256.129 64.83 256.013 64.9268 255.878 64.9268V64.9268Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.111 55.3449C369.139 52.7219 361.155 50.8054 358.952 48.1824C357.821 46.837 357.821 44.3495 358.091 42.2298C358.874 41.7265 359.532 41.2232 359.918 40.7586C360.585 39.7907 361.329 38.4356 362.074 36.9451C362.296 37.1677 362.605 37.3419 362.992 37.3322C364.036 37.3032 368.028 31.8636 367.003 30.5957C366.414 29.8794 365.466 30.4989 364.761 31.1667C365.814 28.747 366.559 26.8886 366.559 26.8886H366.52C366.617 26.5789 366.713 26.2788 366.791 25.9594C368.376 19.6003 364.509 14.4414 358.159 14.4414C351.809 14.4414 345.372 19.6003 343.786 25.9594C343.709 26.2691 343.651 26.5789 343.593 26.8886H343.554C343.554 26.8886 343.371 28.747 343.226 31.1667C342.849 30.4989 342.211 29.8697 341.264 30.5957C339.611 31.8539 340.887 37.2935 341.921 37.3322C342.308 37.3419 342.694 37.1677 343.032 36.9451C343.032 38.4356 343.11 39.7907 343.293 40.7586C343.487 41.3297 344.038 41.9588 344.763 42.5686C343.97 44.6108 342.771 46.9145 341.07 48.1824C337.552 50.8054 328.621 52.7219 325.344 55.3449C322.396 57.7065 319.767 64.6077 319.274 65.9627H371.894C372.078 64.598 372.88 57.7065 371.111 55.3449Z",
    fill: "#8DBCF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.234 140.443H142.868C140.683 140.443 139.098 138.381 139.649 136.271L159.009 61.7911C159.396 60.3199 160.72 59.2939 162.228 59.2939H369.594C371.778 59.2939 373.363 61.3556 372.813 63.4656L353.452 137.946C353.066 139.417 351.742 140.443 350.234 140.443V140.443Z",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.348 134.877H138.982C136.798 134.877 135.213 132.816 135.763 130.706L155.124 56.2257C155.51 54.7545 156.834 53.7285 158.342 53.7285H365.708C367.893 53.7285 369.478 55.7901 368.927 57.9002L349.567 132.38C349.18 133.851 347.856 134.877 346.348 134.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.051 134.877H307.85",
    stroke: "#EF305E",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.189 53.7285H262.885",
    stroke: "#EF305E",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.607 123.765H282.98C280.834 123.765 279.529 122.023 280.061 119.874L291.824 72.6312C292.356 70.4825 294.53 68.7402 296.676 68.7402H343.303C345.449 68.7402 346.754 70.4825 346.222 72.6312L334.459 119.874C333.927 122.023 331.753 123.765 329.607 123.765Z",
    fill: "#B7DEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.719 123.949L310.798 107.563L304.109 104.727C304.109 104.727 291.64 109.295 290.577 110.398C289.688 111.328 285.213 120.881 283.782 123.949H306.709H306.719Z",
    fill: "#EF305E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.81 123.949C329.916 120.881 330.196 111.318 329.771 110.398C329.259 109.295 319.071 104.727 319.071 104.727L310.971 107.563L306.893 123.949H329.819H329.81Z",
    fill: "#EF305E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.942 123.949L317.331 109.77L303.606 110.554L302.263 123.949H310.942Z",
    fill: "#BEBECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.593 101.727L303.597 103.624L301.634 108.347L301.132 114.813L305.336 113.08L308.603 117.02L312.972 113.39L315.65 115.916L319.69 107.244L318.984 101.891L317.293 101.098L306.593 101.727Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.511 89.3273C307.511 89.3273 306.506 87.043 304.447 88.5626C302.388 90.0822 304.795 95.9477 306.293 94.1861C307.782 92.4245 307.511 89.3273 307.511 89.3273Z",
    fill: "#FB8E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.184 89.2015C322.184 89.2015 324.136 86.7818 325.615 88.1368C327.094 89.4919 322.242 95.6961 321.439 94.041C320.637 92.3859 322.184 89.2015 322.184 89.2015Z",
    fill: "#FB8E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.592 106.305L319.7 95.1162L307.511 96.1712L304.824 106.673C304.824 106.673 306.951 111.648 309.241 113.855C309.241 113.855 316.326 107.718 317.602 106.295L317.592 106.305Z",
    fill: "#FB8877"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.48 84.6915C327.026 86.0562 325.905 86.395 325.827 87.1887C325.74 87.9823 325.238 90.0246 324.465 90.8183C323.691 91.612 323.295 91.8346 323.295 91.8346C323.295 91.8346 312.837 94.7867 307.53 90.7021C307.53 90.7021 307.182 89.1535 307.55 87.3048C307.907 85.4755 307.018 85.1464 308.052 84.2462C309.087 83.3461 309.396 82.5427 309.415 81.5265C309.435 80.5102 309.522 79.2616 310.575 78.2356C311.638 77.2193 312.586 77.5581 313.62 76.6482C313.62 76.6482 315.147 74.0833 317.157 73.7929C319.168 73.5026 323.421 72.4282 325.943 75.5448C328.466 78.6518 327.306 81.3813 328.031 82.3492C328.756 83.3171 327.48 84.7012 327.48 84.7012V84.6915Z",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.424 87.4014C307.424 87.4014 302.485 101.01 311.783 102.036C319.999 102.23 322.908 92.1925 324.087 87.0433C325.267 81.894 324.532 76.5125 317.959 76.6867C311.387 76.861 308.139 84.3525 307.424 87.4014Z",
    fill: "#FBA990"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.005 82.5142C310.005 82.5142 310.614 83.6079 310.053 84.7017C309.492 85.8051 307.956 86.2213 307.733 87.6731C307.501 89.125 306.834 92.1448 306.419 92.2803C306.003 92.4158 306.303 89.3282 306.37 88.2732C306.438 87.2182 307.221 82.853 309.415 80.0751C311.609 77.2972 312.962 76.1261 316.867 75.4969C320.772 74.8581 323.73 76.5035 324.812 78.8943C325.895 81.2753 324.165 87.3537 324.165 87.3537C324.165 87.3537 324.426 84.4694 323.459 83.7918C322.493 83.1143 321.7 82.611 321.855 82.2142C322.019 81.8173 318.762 83.2498 315.514 82.2142C312.266 81.1688 311.213 81.6431 310.681 81.9819C310.14 82.3206 310.014 82.5239 310.014 82.5239L310.005 82.5142Z",
    fill: "#713336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.813 108.502C300.736 108.821 296.28 119.449 296.28 119.449L300.194 121.414L299.092 123.621",
    stroke: "#022755",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.086 108.502C320.009 108.821 319.168 119.449 319.168 119.449L314.268 121.414V123.621",
    stroke: "#022755",
    strokeWidth: 0.49,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.607 123.765H282.98C280.834 123.765 279.529 122.023 280.061 119.874L291.824 72.6312C292.356 70.4825 294.53 68.7402 296.676 68.7402H343.303C345.449 68.7402 346.754 70.4825 346.222 72.6312L334.459 119.874C333.927 122.023 331.753 123.765 329.607 123.765Z",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.418 71.5186H239.572",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.87 104.862H234.024",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.21 92.2705H264.364",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.572 82.6299H187.214",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.605 92.2705H184.256",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.045 71.5186H276.765",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.649 120.514H225.248C225.054 120.514 224.909 120.33 224.958 120.146L226.678 113.535C226.717 113.409 226.833 113.312 226.968 113.312H265.369C265.563 113.312 265.708 113.496 265.659 113.68L263.939 120.291C263.9 120.417 263.784 120.514 263.649 120.514V120.514Z",
    stroke: "#7094D8",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.911 120.514H177.509C177.316 120.514 177.171 120.33 177.219 120.146L178.94 113.535C178.978 113.409 179.094 113.312 179.23 113.312H217.631C217.825 113.312 217.97 113.496 217.921 113.68L216.201 120.291C216.172 120.417 216.046 120.514 215.911 120.514Z",
    stroke: "#7094D8",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.111 45.3945H305.076",
    stroke: "#7094D8",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M348.571 241.23H141.195C139.011 241.23 137.426 239.168 137.977 237.058L157.337 162.578C157.724 161.107 159.048 160.081 160.556 160.081H367.922C370.106 160.081 371.691 162.143 371.14 164.253L351.78 238.733C351.393 240.204 350.069 241.23 348.561 241.23H348.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.641 176.013H241.795",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.083 209.356H236.247",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.434 196.765H266.587",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.786 187.124H189.437",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.828 196.765H186.479",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.268 176.013H278.988",
    stroke: "#73A5FF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.872 225.008H227.471C227.277 225.008 227.132 224.824 227.181 224.64L228.901 218.029C228.94 217.903 229.056 217.807 229.191 217.807H267.593C267.786 217.807 267.931 217.991 267.883 218.174L266.162 224.785C266.133 224.911 266.007 225.008 265.872 225.008V225.008Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.133 225.008H179.732C179.539 225.008 179.394 224.824 179.442 224.64L181.162 218.029C181.201 217.903 181.317 217.807 181.452 217.807H219.854C220.047 217.807 220.192 217.991 220.144 218.174L218.423 224.785C218.385 224.911 218.269 225.008 218.133 225.008Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.367 215.416C331.395 212.793 323.411 210.877 321.208 208.254C320.077 206.908 320.077 204.421 320.347 202.301C321.13 201.798 321.788 201.294 322.174 200.83C322.841 199.862 323.585 198.507 324.33 197.016C324.552 197.239 324.861 197.413 325.248 197.404C326.292 197.374 330.284 191.935 329.259 190.667C328.669 189.951 327.722 190.57 327.017 191.238C328.07 188.818 328.814 186.96 328.814 186.96H328.776C328.872 186.65 328.969 186.35 329.046 186.031C330.632 179.672 326.765 174.513 320.415 174.513C314.065 174.513 307.627 179.672 306.042 186.031C305.965 186.34 305.907 186.65 305.849 186.96H305.81C305.81 186.96 305.627 188.818 305.482 191.238C305.105 190.57 304.467 189.941 303.52 190.667C301.867 191.925 303.143 197.365 304.177 197.404C304.563 197.413 304.95 197.239 305.288 197.016C305.288 198.507 305.366 199.862 305.549 200.83C305.743 201.401 306.294 202.03 307.018 202.64C306.226 204.682 305.027 206.986 303.326 208.254C299.808 210.877 290.877 212.793 287.6 215.416C284.652 217.778 282.023 224.679 281.53 226.034H334.15C334.333 224.669 335.136 217.778 333.367 215.416Z",
    fill: "#8DBCF8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.104 340.536H119.738C117.554 340.536 115.968 338.475 116.519 336.365L135.88 261.885C136.266 260.414 137.59 259.388 139.098 259.388H346.464C348.648 259.388 350.234 261.449 349.683 263.559L330.322 338.039C329.936 339.51 328.612 340.536 327.104 340.536Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.174 275.319H220.337",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.626 308.663H214.78",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.966 296.071H245.13",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.328 286.431H167.969",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.37 296.071H165.011",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.801 275.319H257.521",
    stroke: "#8BBCFF",
    strokeWidth: 3.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.405 324.314H206.003C205.81 324.314 205.665 324.131 205.713 323.947L207.434 317.336C207.473 317.21 207.589 317.113 207.724 317.113H246.125C246.319 317.113 246.464 317.297 246.415 317.481L244.695 324.092C244.666 324.218 244.54 324.314 244.405 324.314Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.676 324.314H158.274C158.081 324.314 157.936 324.131 157.984 323.947L159.705 317.336C159.744 317.21 159.86 317.113 159.995 317.113H198.396C198.59 317.113 198.735 317.297 198.686 317.481L196.966 324.092C196.937 324.218 196.811 324.314 196.676 324.314Z",
    stroke: "#84AEE5",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.9 314.723C309.928 312.1 301.944 310.183 299.74 307.56C298.609 306.215 298.609 303.727 298.88 301.608C299.663 301.104 300.32 300.601 300.707 300.137C301.374 299.169 302.118 297.814 302.862 296.323C303.085 296.546 303.394 296.72 303.781 296.71C304.824 296.681 308.816 291.242 307.792 289.974C307.202 289.257 306.255 289.877 305.549 290.545C306.603 288.125 307.347 286.267 307.347 286.267H307.308C307.405 285.957 307.502 285.657 307.579 285.337C309.164 278.978 305.298 273.819 298.948 273.819C292.597 273.819 286.16 278.978 284.575 285.337C284.498 285.647 284.44 285.957 284.382 286.267H284.343C284.343 286.267 284.159 288.125 284.014 290.545C283.637 289.877 282.999 289.248 282.052 289.974C280.399 291.232 281.675 296.671 282.709 296.71C283.096 296.72 283.483 296.546 283.821 296.323C283.821 297.814 283.898 299.169 284.082 300.137C284.275 300.708 284.826 301.337 285.551 301.947C284.759 303.989 283.56 306.292 281.859 307.56C278.341 310.183 269.41 312.1 266.133 314.723C263.185 317.084 260.556 323.986 260.063 325.341H312.683C312.866 323.976 313.668 317.084 311.9 314.723Z",
    fill: "#8DBCF8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.648 340.904H322.648",
    stroke: "#B5CDE7",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.831 241.598H247.904",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.066 241.598H289.533",
    stroke: "white",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.759 160.449H368.202C370.386 160.449 371.952 162.569 371.304 164.66L368.163 174.9",
    stroke: "#7094D8",
    strokeWidth: 1.15,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.16 29.4918H121.362C120.405 29.4918 119.825 28.7174 120.067 27.7689L121.014 23.9651C121.255 23.0068 122.212 22.2422 123.169 22.2422H126.968C127.925 22.2422 128.505 23.0165 128.263 23.9651L127.316 27.7689C127.074 28.7271 126.117 29.4918 125.16 29.4918Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.386 40.6324H118.587C117.63 40.6324 117.05 39.8581 117.292 38.9095L118.239 35.1057C118.481 34.1475 119.438 33.3828 120.395 33.3828H124.193C125.15 33.3828 125.73 34.1571 125.489 35.1057L124.541 38.9095C124.3 39.8677 123.343 40.6324 122.386 40.6324Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.458 40.6324H130.66C129.703 40.6324 129.123 39.8581 129.364 38.9095L130.312 35.1057C130.553 34.1475 131.51 33.3828 132.467 33.3828H136.266C137.223 33.3828 137.802 34.1571 137.561 35.1057L136.614 38.9095C136.372 39.8677 135.415 40.6324 134.458 40.6324Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.53 40.6324H142.732C141.775 40.6324 141.195 39.8581 141.437 38.9095L142.384 35.1057C142.626 34.1475 143.582 33.3828 144.539 33.3828H148.338C149.295 33.3828 149.875 34.1571 149.633 35.1057L148.686 38.9095C148.444 39.8677 147.487 40.6324 146.53 40.6324Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.545 52.0337H115.746C114.789 52.0337 114.209 51.2594 114.451 50.3109L115.398 46.507C115.64 45.5488 116.597 44.7842 117.553 44.7842H121.352C122.309 44.7842 122.889 45.5585 122.647 46.507L121.7 50.3109C121.458 51.2691 120.501 52.0337 119.545 52.0337Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.509 64.2095H112.711C111.754 64.2095 111.174 63.4352 111.416 62.4867L112.363 58.6828C112.605 57.7246 113.561 56.96 114.518 56.96H118.317C119.274 56.96 119.854 57.7343 119.612 58.6828L118.665 62.4867C118.423 63.4449 117.466 64.2095 116.509 64.2095Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.617 52.0337H127.818C126.861 52.0337 126.281 51.2594 126.523 50.3109L127.47 46.507C127.712 45.5488 128.669 44.7842 129.626 44.7842H133.424C134.381 44.7842 134.961 45.5585 134.72 46.507L133.772 50.3109C133.531 51.2691 132.574 52.0337 131.617 52.0337Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33 73.2789H122.531C121.574 73.2789 120.994 72.5045 121.236 71.556L122.183 67.7522C122.425 66.7939 123.382 66.0293 124.339 66.0293H128.137C129.094 66.0293 129.674 66.8036 129.432 67.7522L128.485 71.556C128.244 72.5142 127.287 73.2789 126.33 73.2789Z",
    fill: "#BFD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.025 7.36569H185.967C185.909 7.36569 185.851 7.34633 185.793 7.34633C185.406 7.32698 185.01 7.30762 184.604 7.30762C173.353 7.30762 161.967 16.3381 158.971 27.5561L158.835 28.0884C158.826 28.1465 158.816 28.2046 158.797 28.253L158.71 28.5917H158.719C156.255 39.9646 163.533 49.0144 175.199 48.5402C185.831 48.1046 196.56 39.6064 199.759 29.066C203.22 17.6351 196.918 8.11097 186.025 7.34633V7.36569ZM193.786 28.6982C191.544 36.1898 183.869 42.2391 176.33 42.4714C168.221 42.7328 163.156 36.422 164.828 28.4949L165.06 27.5561C167.215 19.6967 175.209 13.3957 183.106 13.3957C183.512 13.3957 183.918 13.4151 184.304 13.4538C191.843 14.0926 196.183 20.7421 193.796 28.6982H193.786Z",
    fill: "#EBEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.913 10.8795C184.565 12.283 185.212 13.4928 186.488 13.8316C192.636 15.4577 195.922 21.5554 193.776 28.6985C191.534 36.1901 183.859 42.2395 176.32 42.4718C168.916 42.7041 164.054 37.4871 164.528 30.5472C164.625 29.1147 163.61 28.0888 162.16 28.0888C160.275 28.0888 158.4 29.7923 158.274 31.641C157.607 41.5329 164.596 48.9761 175.199 48.5405C185.831 48.1049 196.56 39.6068 199.759 29.0663C202.842 18.8937 198.193 10.2213 189.446 7.89837C187.638 7.41442 185.415 8.86627 184.913 10.8505V10.8795Z",
    fill: "#98F49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.271 5.28464H237.213C237.146 5.28464 237.068 5.27496 237.001 5.26528C236.624 5.24592 236.237 5.22656 235.85 5.22656C224.474 5.22656 212.943 14.4603 210.111 25.8622C207.269 37.2544 214.199 46.4978 225.576 46.4978C225.962 46.4978 226.349 46.4785 226.745 46.4591C226.823 46.4591 226.89 46.4591 226.968 46.4494H227.026C237.861 45.7138 248.483 36.8769 251.277 26.0461C251.296 25.988 251.315 25.9299 251.325 25.8622C254.041 14.954 247.807 6.02024 237.271 5.28464ZM228.118 40.3613H228.06C227.818 40.3807 227.577 40.3904 227.345 40.3904C227.258 40.3904 227.18 40.3904 227.093 40.3904C219.071 40.3904 214.19 33.8764 216.19 25.8428C218.191 17.8093 226.31 11.2953 234.333 11.2953C234.42 11.2953 234.497 11.2953 234.574 11.2953C234.816 11.2953 235.048 11.305 235.28 11.3243H235.338C242.752 11.8567 247.14 18.148 245.226 25.8332C245.207 25.8912 245.197 25.9493 245.178 26.0171C243.187 33.6247 235.725 39.829 228.108 40.342L228.118 40.3613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.308 28.5818C241.756 34.4182 236.025 39.0158 229.935 40.1385C228.408 40.4192 227.036 41.6581 226.668 43.139C226.195 45.0555 227.586 46.4879 229.549 46.1298C238.238 44.5521 246.405 37.9898 250.03 29.6658C250.852 27.7881 249.856 26.0459 247.942 26.0459C246.454 26.0459 244.956 27.1203 244.308 28.5818Z",
    fill: "#F96D8E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.612 77.8965H144.211C144.018 77.8965 143.873 77.7126 143.921 77.5287L145.641 70.9179C145.68 70.7921 145.796 70.6953 145.931 70.6953H184.333C184.526 70.6953 184.671 70.8792 184.623 71.0631L182.902 77.6739C182.864 77.7997 182.748 77.8965 182.612 77.8965Z",
    fill: "#13097C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.728 108.554C368.722 101.484 370.74 90.6922 365.234 84.4498C359.729 78.2074 348.785 78.8784 340.791 85.9485C332.797 93.0186 330.779 103.81 336.284 110.053C341.79 116.295 352.734 115.624 360.728 108.554Z",
    fill: "#6BD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.973 115.606C375.335 118.19 372.716 120.281 370.144 120.281C367.573 120.281 365.998 118.19 366.646 115.606C367.283 113.021 369.903 110.931 372.474 110.931C375.045 110.931 376.62 113.021 375.973 115.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.377 105.946C345.845 105.946 345.352 105.743 345.043 105.327L340.635 99.4516C340.017 98.6289 340.355 97.3029 341.37 96.4802C342.394 95.6575 343.719 95.6575 344.337 96.4802L347.633 100.874L359.396 91.4471C360.421 90.6244 361.745 90.6244 362.364 91.4471C362.982 92.2698 362.644 93.5959 361.629 94.4186L348.01 105.336C347.498 105.743 346.908 105.956 346.377 105.956V105.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4931 395.01C127.652 395.01 160.207 392.271 160.207 388.893C160.207 385.514 127.652 382.775 87.4931 382.775C47.3341 382.775 14.7788 385.514 14.7788 388.893C14.7788 392.271 47.3341 395.01 87.4931 395.01Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2162 369.225C58.2162 369.225 59.7627 365.915 65.4848 366.796C71.2068 367.676 71.8737 368.78 72.5407 371.654C73.1979 374.519 75.189 377.617 76.5036 378.275C77.8277 378.933 82.6702 382.243 86.6428 382.911C90.6057 383.569 91.0503 385.999 90.1707 387.102C89.2912 388.206 74.2998 389.086 70.9942 388.651C70.9942 388.651 59.7531 388.428 57.1144 387.547C54.466 386.667 57.9939 370.338 58.2162 369.235V369.225Z",
    fill: "#2D2737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8562 291.648C51.8562 291.648 50.1841 282.511 59.8207 279.443C69.4573 276.375 71.2841 280.837 74.2031 289.17C77.1221 297.504 71.6997 368.712 71.6997 368.712C71.6997 368.712 60.6036 370.609 57.7522 368.925C57.7522 368.925 49.2948 322.572 49.8844 309.854C50.474 297.136 51.8659 291.648 51.8659 291.648H51.8562Z",
    fill: "#FFBB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5635 366.128C56.5635 366.128 69.1288 365.024 73.0917 364.366L72.8693 370.106C72.8693 370.106 62.9524 371.867 56.7858 370.987L56.5635 366.128Z",
    fill: "#E6A71B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4799 113.235C53.4799 113.235 45.5445 113.681 40.702 131.771C35.8499 149.87 32.7666 171.929 34.5354 177.668C36.2945 183.408 55.2488 198.856 62.3046 198.856C69.3605 198.856 69.7955 193.561 68.4713 189.148C67.1471 184.734 53.4896 172.819 53.4896 172.819C53.4896 172.819 64.5084 137.51 64.0638 128.247C63.6192 118.985 58.3321 113.245 53.4896 113.245L53.4799 113.235Z",
    fill: "#DF2A55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.814 107.844L151.499 107.98L154.447 102.133C154.447 102.133 161.948 101.659 163.146 104.834L159.705 112.471L152.814 107.854V107.844Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.028 91.2246C157.028 91.2246 156.738 85.2526 158.855 84.4009C160.981 83.5491 163.359 85.2042 163.359 85.2042C163.359 85.2042 166.79 84.8558 167.892 86.3173C168.994 87.7788 168.897 90.005 168.897 90.005C168.897 90.005 170.831 90.4406 171.343 92.2796C171.845 94.1283 170.947 97.6901 170.947 97.6901C170.947 97.6901 168.704 100.449 166.104 99.7614C163.514 99.0742 157.028 91.2052 157.028 91.2052V91.2246Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.103 96.0548C153.103 96.0548 152.311 88.2342 153.152 87.1985C153.993 86.1629 162.595 74.248 162.595 74.248C162.595 74.248 164.383 76.2806 163.349 78.5939C162.324 80.9072 158.275 87.9438 158.275 87.9438L158.255 93.9545C158.255 93.9545 155.607 95.8032 153.103 96.0645V96.0548Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.742 102.307C153.742 102.307 151.683 89.7538 153.084 88.0213C154.486 86.2984 161.368 87.305 162.673 87.7987C163.987 88.2923 167.621 92.9866 168.124 94.8256C168.627 96.6646 165.205 103.343 163.146 104.814C161.087 106.286 154.93 104.708 153.742 102.298V102.307Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.899 110.592L151.547 105.734C151.547 105.734 157.714 104.63 160.807 109.489C161.687 111.251 161.252 111.251 161.252 111.251L159.27 115.219L148.909 110.583L148.899 110.592Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7396 112.8L68.0267 93.819C68.0267 93.819 78.6009 90.7314 85.2122 97.7874L87.4159 100.875V113.235C87.4159 113.235 76.3971 115.442 62.73 112.79L62.7396 112.8Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1208 57.4647C86.1208 57.4647 92.6451 59.1392 96.3373 69.1569C100.03 79.1844 97.5649 100.488 95.1098 102.995C92.6547 105.502 84.2062 106.349 76.6087 97.487C65.6479 93.8671 60.13 86.0855 58.1679 78.5649C54.4176 64.1529 66.9346 49.3247 86.1208 57.4744V57.4647Z",
    fill: "#FEB2B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9708 214.971C47.9708 214.971 44.0079 238.143 47.9708 264.624C51.9337 291.106 59.8691 293.758 67.1473 293.758C74.4255 293.758 76.407 272.571 77.7215 263.308C79.0457 254.035 84.3328 222.259 74.4158 214.981C64.4989 207.702 53.2578 207.034 47.9708 214.981V214.971Z",
    fill: "#FFBB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7397 246.089C75.7397 246.089 67.8043 224.901 81.6938 215.639C95.5736 206.366 106.157 207.692 109.463 222.917C112.769 238.142 113.426 290.448 108.806 301.036C104.176 311.625 87.6478 295.074 75.7494 246.089H75.7397Z",
    fill: "#FFBB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8404 58.3647C98.8404 58.3647 101.972 62.4396 100.087 67.1339C98.2121 71.8379 91.3302 73.7156 91.3302 73.7156C91.3302 73.7156 93.5243 76.8516 91.3302 81.2362L89.7644 83.7431C89.7644 83.7431 91.9585 88.7568 91.3302 90.0054C90.702 91.254 88.5175 90.9443 88.5175 90.9443C88.5175 90.9443 86.0141 84.0528 85.0766 84.6819C84.139 85.3111 81.6356 88.4374 81.6356 91.2637C81.6356 94.0899 82.5732 96.2774 81.9449 98.1551C81.3167 100.033 71.6221 100.033 67.5528 99.4037C63.4836 98.7746 57.23 86.2499 55.6641 80.6071C55.6641 80.6071 53.47 72.7768 56.6017 66.1951C56.6017 66.1951 55.9734 60.5522 61.2992 54.919C66.6153 49.2762 83.5107 51.1636 86.3234 53.351C86.3234 53.351 86.0141 50.215 89.1361 50.8442C92.2678 51.4733 96.9556 54.2899 98.8307 58.3647H98.8404Z",
    fill: "#13097C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4551 86.8791C89.4551 86.8791 88.5176 82.8043 85.0766 84.682C81.6357 86.5597 85.7049 96.2775 88.5176 95.6483C91.3303 95.0192 90.0834 88.4471 89.4551 86.8791Z",
    fill: "#FF9B97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9365 112.693C59.9365 112.693 61.4154 107.496 62.7396 107.06C64.0637 106.615 80.3696 104.853 89.1846 110.148C93.1475 113.235 92.7126 115.442 92.7126 115.442C92.7126 115.442 66.4028 110.39 59.9462 112.693H59.9365Z",
    fill: "#DEE0E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5631 111.473C56.5631 111.473 83.8878 109.712 103.277 118.094C112.092 122.507 132.254 142.475 132.254 142.475L148.125 109.373C148.125 109.373 157.047 106.169 160.575 114.561C160.575 114.561 150.551 153.616 142.171 165.976C136.884 170.389 111.647 156.045 111.647 156.045C111.647 156.045 115.61 207.237 114.296 230.196C112.537 234.61 78.1561 236.816 71.9894 236.371C65.8228 235.926 44.2201 228.87 43.7852 227.544C43.3406 226.218 46.8685 173.254 45.989 167.079C45.1094 160.904 42.461 130.444 43.3406 126.031C44.2201 121.617 48.1927 113.235 56.5631 111.464V111.473Z",
    fill: "#EF305E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6569 370.541C85.6569 370.541 87.2034 367.231 92.9254 368.112C98.6571 368.993 99.3144 370.096 99.9813 372.971C100.648 375.845 102.63 378.933 103.944 379.591C105.259 380.249 110.111 383.56 114.083 384.227C118.046 384.886 118.491 387.315 117.611 388.418C116.732 389.522 101.74 390.403 98.4348 389.967C98.4348 389.967 87.1937 389.745 84.555 388.864C81.9163 387.983 85.4346 371.654 85.6569 370.551V370.541Z",
    fill: "#3E3343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2958 293.09C88.2958 293.09 87.6385 283.817 97.5554 281.833C107.472 279.849 108.797 284.485 110.778 293.09C112.759 301.695 99.5369 371.867 99.5369 371.867C99.5369 371.867 88.2958 372.526 85.6571 370.541C85.6571 370.541 82.3514 323.54 84.3329 310.957C86.3143 298.375 88.2958 293.08 88.2958 293.08V293.09Z",
    fill: "#FFBB22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7775 371.645C84.7775 371.645 93.3702 374.074 100.648 372.748L101.306 367.677L84.5552 366.573L84.7775 371.645Z",
    fill: "#E6A71B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1953_40758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 409,
    height: 395,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg);
export default __webpack_public_path__ + "static/media/banner-img.567b8c938fc675746fcf38e3db83a977.svg";
export { ForwardRef as ReactComponent };